import { Link } from "react-router-dom";
import { Logo } from "../components/Logo";
import { buttonVariants } from "../components/ui/Button";

export default function NotFound() {
  return (
    <div className="relative flex min-h-screen flex-col items-center justify-center overflow-hidden px-6 text-center">
      <div className="pointer-events-none absolute inset-0 bg-aurora" />
      <div className="relative">
        <Link to="/">
          <Logo />
        </Link>
        <p className="mt-12 text-7xl font-black text-gradient">404</p>
        <h1 className="mt-4 text-2xl font-bold text-slate-900">Page not found</h1>
        <p className="mt-2 max-w-sm text-slate-500">
          The page you're looking for doesn't exist or has moved.
        </p>
        <Link to="/" className={buttonVariants({ className: "mt-8" })}>
          Back home
        </Link>
      </div>
    </div>
  );
}
